<template>
    <b-row>
        <b-col class="OTListBlock">
            <b-row v-if="knowledgeBases.length === 0">
                <b-col class="OTnoObjectRunning">No knowledge bases are available.</b-col>
            </b-row>

            <b-row v-else>
                <b-col cols="12" class="OTListBlockSortedLabel">Sorted by modified date</b-col>
                <b-col cols="12">
                    <b-row v-for="kb in kbList" class="OTListBlockRow" :key="kb.name.title + kb.name.language.id">
                        <b-col class="OTListBlockLabel">
                            {{ kb.label != null ? kb.label : kb.name.title }} - {{ kb.name.language.id }}<br>
                            <span
                                class="OTListBlockDate"
                            >{{ kb.modified }}</span>
                        </b-col>
                        <b-col class="text-right OTListBlockValue">{{kb.categorySize}} Categories</b-col>
                    </b-row>
                </b-col>
            </b-row>
        </b-col>
    </b-row>
</template>

<script>
import { get } from "vuex-pathify";
import moment from 'moment';

export default {
    components: {},
    computed: {
        loadingKb: get("annotationStudio/loadingKnowledgeBases"),
        knowledgeBases: get("annotationStudio/knowledgeBases"),
        kbList() {
            // Processed (sorted/row limited) list of KBs
            const kb = JSON.parse(JSON.stringify(this.knowledgeBases));
            return kb.sort((a, b) => {

                const adate = moment(a.modified, 'DD-MM-YYYY HH:mm:ss');
                const bdate = moment(b.modified, 'DD-MM-YYYY HH:mm:ss');

                if (adate.isAfter(bdate)) {
                    return -1;
                } else if (adate.isBefore(bdate)) {
                    return 1;
                } else {
                    return 0;
                }
            }).slice(0,5);
        }
    },

    mounted() {
        this.$store.dispatch("annotationStudio/loadKnowledgeBases");
    }
};
</script>

